document.addEventListener('DOMContentLoaded', function () {
  // Function to insert schema into the <head>
  function insertSchema(schema) {
    var script = document.createElement('script');
    script.type = 'application/ld+json';
    script.innerHTML = JSON.stringify(schema);
    document.head.appendChild(script);
  }

  // Define your static paths and their corresponding schema
  var schemaMap = {
    '/products/club-starter-bundle': {
      '@context': 'https://schema.org/',
      '@type': 'Product',
      name: 'Club Starter Bundle',
      image:
        'https://www.spikeball.com/cdn/shop/files/media_a91981b1-7e5b-468a-bec3-23268c1b29e5.png?v=1721870362&width=800',
      description:
        'The perfect bundle for anyone trying to start a club at their high school, college, or local hangout. Includes 3 Combo Meal Kits and 25 Stickers.',
      brand: {
        '@type': 'Brand',
        name: 'Spikeball',
      },
      offers: {
        '@type': 'Offer',
        url: 'https://www.spikeball.com/products/club-starter-bundle',
        priceCurrency: 'USD',
        price: '149.00',
        priceValidUntil: '2024-12-31',
        itemCondition: 'https://schema.org/NewCondition',
        availability: 'https://schema.org/InStock',
        seller: {
          '@type': 'Organization',
          name: 'Spikeball',
        },
      },
      aggregateRating: {
        '@type': 'AggregateRating',
        ratingValue: '0',
        reviewCount: '0',
      },
    },
    '/products/club-starter-pro-bundle': {
      '@context': 'https://schema.org/',
      '@type': 'Product',
      name: 'Club Starter Pro Bundle',
      image:
        'https://www.spikeball.com/cdn/shop/files/media_37abb14f-ba76-493c-a067-5f66b5c77086.png?v=1721870369&width=800',
      description:
        'The perfect bundle for anyone trying to start a pro club at their high school, college, or local hangout. Includes 3 Pro Kits, 3 extra Pro Balls, and 25 Stickers.',
      brand: {
        '@type': 'Brand',
        name: 'Spikeball',
      },
      offers: {
        '@type': 'Offer',
        url: 'https://www.spikeball.com/products/club-starter-pro-bundle',
        priceCurrency: 'USD',
        price: '249.00',
        priceValidUntil: '2024-12-31',
        itemCondition: 'https://schema.org/NewCondition',
        availability: 'https://schema.org/InStock',
        seller: {
          '@type': 'Organization',
          name: 'Spikeball',
        },
      },
      aggregateRating: {
        '@type': 'AggregateRating',
        ratingValue: '0',
        reviewCount: '0',
      },
    },
    '/products/club-starter-pro-bundle-3-sets-10-extra-balls': {
      '@context': 'https://schema.org/',
      '@type': 'Product',
      name: 'Club Starter Pro Bundle - 3 Sets + 10 Extra Balls',
      image:
        'https://www.spikeball.com/cdn/shop/files/media_d19cb94f-a399-4965-8c5c-7c3f66545d19.jpg?v=1721870372&width=800',
      description:
        'The perfect bundle for anyone trying to start a pro club at their high school, college, or local hangout. Includes 3 Pro Kits and 10 extra Pro Balls.',
      brand: {
        '@type': 'Brand',
        name: 'Spikeball',
      },
      offers: {
        '@type': 'Offer',
        url: 'https://www.spikeball.com/products/club-starter-pro-bundle',
        priceCurrency: 'USD',
        price: '259.00',
        priceValidUntil: '2024-12-31',
        itemCondition: 'https://schema.org/NewCondition',
        availability: 'https://schema.org/InStock',
        seller: {
          '@type': 'Organization',
          name: 'Spikeball',
        },
      },
      aggregateRating: {
        '@type': 'AggregateRating',
        ratingValue: '4',
        reviewCount: '2',
      },
      review: [
        {
          '@type': 'Review',
          author: {
            '@type': 'Person',
            name: 'Krish M.',
          },
          reviewRating: {
            '@type': 'Rating',
            ratingValue: '3',
            bestRating: '5',
          },
          datePublished: '2024-06-20',
          description:
            'Really fun, but arrived very delayed and did not come with all parts and stickers. Customer service has yet to get back to me within a day.',
        },
        {
          '@type': 'Review',
          author: {
            '@type': 'Person',
            name: 'Deanna',
          },
          reviewRating: {
            '@type': 'Rating',
            ratingValue: '5',
            bestRating: '5',
          },
          datePublished: '2024-05-30',
          description:
            "The quality continues to improve. But it's a great game to play, and I'm even more excited to take my game on the road.",
        },
      ],
    },
    '/products/limited-edition-blackout-pro-set': {
      '@context': 'https://schema.org/',
      '@type': 'Product',
      name: 'Limited Edition Blackout Pro Set',
      image:
        'https://www.spikeball.com/cdn/shop/files/media_f8e917e2-ec8e-4073-b2ef-2d679e9e2b14.jpg?v=1728277705&width=800',
      description:
        "You never know what you'll find when you're spring cleaning. Fortunately, we found these and they need a new home. Only 500 available so grab 'em whilst they're hot as coals. Includes: Limited Edition Blackout Pro Set, 2x Regular Pro balls, 2x Glow Balls, Pro Carry Bag, Ball Pump.",
      brand: {
        '@type': 'Brand',
        name: 'Spikeball',
      },
      offers: {
        '@type': 'Offer',
        url: 'https://www.spikeball.com/products/limited-edition-blackout-pro-set',
        priceCurrency: 'USD',
        price: '125.00',
        priceValidUntil: '2024-12-31',
        itemCondition: 'https://schema.org/NewCondition',
        availability: 'https://schema.org/InStock',
        seller: {
          '@type': 'Organization',
          name: 'Spikeball',
        },
      },
      aggregateRating: {
        '@type': 'AggregateRating',
        ratingValue: '4.4',
        reviewCount: '7',
      },
      review: [
        {
          '@type': 'Review',
          author: {
            '@type': 'Person',
            name: 'Taylor',
          },
          reviewRating: {
            '@type': 'Rating',
            ratingValue: '5',
            bestRating: '5',
          },
          datePublished: '2024-09-01',
          description:
            'Blackout is my favorite LE set so far - wish it came with a special edition box and blackout balls instead of the standard pros/glow in the darks, but overall great look.',
        },
        {
          '@type': 'Review',
          author: {
            '@type': 'Person',
            name: 'Frantz',
          },
          reviewRating: {
            '@type': 'Rating',
            ratingValue: '5',
            bestRating: '5',
          },
          datePublished: '2024-08-06',
          description: 'This product feels very premium, I have been having so much fun with my new set!!',
        },
        {
          '@type': 'Review',
          author: {
            '@type': 'Person',
            name: 'Stephen',
          },
          reviewRating: {
            '@type': 'Rating',
            ratingValue: '5',
            bestRating: '5',
          },
          datePublished: '2024-07-26',
          description:
            'Me and a bunch of friends play every week. We got this net and use it as our championship net. Feels pretty awesome when you win on the new net.',
        },
        {
          '@type': 'Review',
          author: {
            '@type': 'Person',
            name: 'Owen',
          },
          reviewRating: {
            '@type': 'Rating',
            ratingValue: '5',
            bestRating: '5',
          },
          datePublished: '2024-07-03',
          description: 'Great quality.',
        },
        {
          '@type': 'Review',
          author: {
            '@type': 'Person',
            name: 'Samuel',
          },
          reviewRating: {
            '@type': 'Rating',
            ratingValue: '5',
            bestRating: '5',
          },
          datePublished: '2024-06-22',
          description:
            'Works great and is a big improvement over the regular spikeball set highly recommend.',
        },
        {
          '@type': 'Review',
          author: {
            '@type': 'Person',
            name: 'Sam',
          },
          reviewRating: {
            '@type': 'Rating',
            ratingValue: '2',
            bestRating: '5',
          },
          datePublished: '2024-05-29',
          description: 'This is not good the plastic feels very cheap and ball come flat.',
        },
        {
          '@type': 'Review',
          author: {
            '@type': 'Person',
            name: 'Anonymous',
          },
          reviewRating: {
            '@type': 'Rating',
            ratingValue: '4',
            bestRating: '5',
          },
          datePublished: '2024-05-25',
          description:
            'Great set, but I wish it came with blackout pro balls instead of normal pro balls. Also, how come this box is just for a normal pro net and doesn’t have a limited edition badge?',
        },
      ],
    },
    '/products/pro-ball-2-pack': {
      '@context': 'https://schema.org/',
      '@type': 'Product',
      name: 'Pro Balls (2 Pack)',
      image:
        'https://www.spikeball.com/cdn/shop/files/media_b227dfbc-8147-4cc3-81ea-1a14f1f84066.jpg?v=1721870887&width=600',
      description:
        'New black and yellow design allows you to track the ball easier. New pips on the ball gives added spin for hard and soft hits alike. Additional Pro Balls give you the opportunity to train like the very best.',
      brand: {
        '@type': 'Brand',
        name: 'Spikeball',
      },
      offers: {
        '@type': 'Offer',
        url: 'https://www.spikeball.com/products/pro-balls-2-pack',
        priceCurrency: 'USD',
        price: '15.00',
        priceValidUntil: '2024-12-31',
        itemCondition: 'https://schema.org/NewCondition',
        availability: 'https://schema.org/InStock',
        seller: {
          '@type': 'Organization',
          name: 'Spikeball',
        },
      },
      aggregateRating: {
        '@type': 'AggregateRating',
        ratingValue: '4.7',
        reviewCount: '238',
      },
      review: [
        {
          '@type': 'Review',
          author: {
            '@type': 'Person',
            name: 'Brandon M.',
          },
          reviewRating: {
            '@type': 'Rating',
            ratingValue: '5',
            bestRating: '5',
          },
          datePublished: '2024-09-15',
          description:
            "The level of play was higher because it's easier to grip and gauge spin action, so we had a blast.",
        },
        {
          '@type': 'Review',
          author: {
            '@type': 'Person',
            name: 'Logan B.',
          },
          reviewRating: {
            '@type': 'Rating',
            ratingValue: '5',
            bestRating: '5',
          },
          datePublished: '2024-08-20',
          description: 'These balls were top notch, really elevated my game through the rough.',
        },
        {
          '@type': 'Review',
          author: {
            '@type': 'Person',
            name: 'Nathan',
          },
          reviewRating: {
            '@type': 'Rating',
            ratingValue: '5',
            bestRating: '5',
          },
          datePublished: '2024-07-12',
          description:
            'The upgraded grip and colorway of the ball allows for players to have a professional feel when playing.',
        },
      ],
      reviewHighlights: {
        '@type': 'ReviewHighlights',
        summary:
          'Customers are talking about these key features: top-notch quality, improved grip, and professional play experience.',
        keywords: [
          {
            name: 'Game',
            mentions: '13% of reviewers',
          },
          {
            name: 'Quality',
            mentions: '9% of reviewers',
          },
          {
            name: 'Grip',
            mentions: '8% of reviewers',
          },
          {
            name: 'Play',
            mentions: '6% of reviewers',
          },
          {
            name: 'Customer service',
            mentions: '5% of reviewers',
          },
        ],
      },
    },
    '/products/pro-kit-spares': {
      '@context': 'https://schema.org/',
      '@type': 'Product',
      name: 'Pro Kit Spares',
      image:
        'https://www.spikeball.com/cdn/shop/files/media_f5279ee4-16eb-45fe-a177-2e910647ef54.jpg?v=1727368862&width=800',
      description:
        "Don't get caught without a spare part! Make sure you can keep spiking if a part gets lost or broken by purchasing the Pro Kit Spares package. Includes 3 Pro Kit rims, 1 Pro Kit leg, and 1 Pro Kit net.",
      brand: {
        '@type': 'Brand',
        name: 'Spikeball',
      },
      offers: {
        '@type': 'Offer',
        url: 'https://www.spikeball.com/products/pro-kit-spares',
        priceCurrency: 'USD',
        price: '29.99',
        priceValidUntil: '2024-12-31',
        itemCondition: 'https://schema.org/NewCondition',
        availability: 'https://schema.org/InStock',
        seller: {
          '@type': 'Organization',
          name: 'Spikeball',
        },
      },
      aggregateRating: {
        '@type': 'AggregateRating',
        ratingValue: '4.7',
        reviewCount: '15',
      },
      review: [
        {
          '@type': 'Review',
          author: {
            '@type': 'Person',
            name: 'Joshua B.',
          },
          reviewRating: {
            '@type': 'Rating',
            ratingValue: '5',
            bestRating: '5',
          },
          datePublished: '2024-07-05',
          description:
            'Might be one of the most underrated things that they sell! Instead of having to buy a whole new kit, you can just replace the bad parts.',
        },
        {
          '@type': 'Review',
          author: {
            '@type': 'Person',
            name: 'Krish M.',
          },
          reviewRating: {
            '@type': 'Rating',
            ratingValue: '1',
            bestRating: '5',
          },
          datePublished: '2024-06-20',
          description:
            'Gave me a torn net and the wrong leg that I could not use after delaying the package delivery 3 times.',
        },
        {
          '@type': 'Review',
          author: {
            '@type': 'Person',
            name: 'Tyler H.',
          },
          reviewRating: {
            '@type': 'Rating',
            ratingValue: '5',
            bestRating: '5',
          },
          datePublished: '2024-02-23',
          description: 'The pieces are great quality and look amazing!',
        },
        {
          '@type': 'Review',
          author: {
            '@type': 'Person',
            name: 'Randy S.',
          },
          reviewRating: {
            '@type': 'Rating',
            ratingValue: '4',
            bestRating: '5',
          },
          datePublished: '2024-02-03',
          description: 'Great but did not have it in the dunkin color.',
        },
        {
          '@type': 'Review',
          author: {
            '@type': 'Person',
            name: 'Tyler W.',
          },
          reviewRating: {
            '@type': 'Rating',
            ratingValue: '5',
            bestRating: '5',
          },
          datePublished: '2024-02-02',
          description:
            'Wonderful product in case any of your parts break. Also, the customer service for my order(s) were amazing. Highly recommend this product!',
        },
      ],
    },
    '/products/spikeball-pro-set': {
      '@context': 'https://schema.org/',
      '@type': 'Product',
      name: 'Pro Set',
      image:
        'https://www.spikeball.com/cdn/shop/files/media_4365f8b9-59db-49a2-80bf-cc8643949240.jpg?v=1724649019&width=800',
      description:
        'This is the official tournament set of the Spikeball Tour Series. The sturdy body design keeps the set stable and net taut during the harshest of plays. The grippy, dimpled Pro Balls help players add topspin on their kills and backspin on their drop shots. Includes: Spikeball Pro set, 2 Spikeball Pro balls, portable ball pump and gauge, carrying bag, and discounted registration for your first Spikeball Tour Series tournament.',
      brand: {
        '@type': 'Brand',
        name: 'Spikeball',
      },
      offers: {
        '@type': 'Offer',
        url: 'https://www.spikeball.com/products/pro-set',
        priceCurrency: 'USD',
        price: '99.00',
        priceValidUntil: '2024-12-31',
        itemCondition: 'https://schema.org/NewCondition',
        availability: 'https://schema.org/InStock',
        seller: {
          '@type': 'Organization',
          name: 'Spikeball',
        },
      },
      aggregateRating: {
        '@type': 'AggregateRating',
        ratingValue: '5',
        reviewCount: '981',
      },
      review: [
        {
          '@type': 'Review',
          author: {
            '@type': 'Person',
            name: 'Jaxsen',
          },
          reviewRating: {
            '@type': 'Rating',
            ratingValue: '5',
            bestRating: '5',
          },
          datePublished: '2024-08-10',
          description:
            'The pro net is a great upgrade from the standard, the quality is great and the balls are fantastic.',
        },
        {
          '@type': 'Review',
          author: {
            '@type': 'Person',
            name: 'Claire R.',
          },
          reviewRating: {
            '@type': 'Rating',
            ratingValue: '5',
            bestRating: '5',
          },
          datePublished: '2024-07-22',
          description: 'The higher quality ball and net really enhance our game play.',
        },
        {
          '@type': 'Review',
          author: {
            '@type': 'Person',
            name: 'Tory W.',
          },
          reviewRating: {
            '@type': 'Rating',
            ratingValue: '5',
            bestRating: '5',
          },
          datePublished: '2024-06-15',
          description:
            "It's sturdy, the ball feels nice, the look is sleek, and the packaging was pretty classy.",
        },
      ],
      reviewHighlights: {
        '@type': 'ReviewHighlights',
        summary:
          'Customers are talking about these key features: game quality, ball sturdiness, and net performance.',
        keywords: [
          {
            name: 'Game',
            mentions: '20% of reviewers',
          },
          {
            name: 'Balls',
            mentions: '12% of reviewers',
          },
          {
            name: 'Net',
            mentions: '11% of reviewers',
          },
          {
            name: 'Quality',
            mentions: '9% of reviewers',
          },
          {
            name: 'Kit',
            mentions: '9% of reviewers',
          },
        ],
      },
    },
    '/products/spikeball-set': {
      '@context': 'https://schema.org/',
      '@type': 'Product',
      name: 'The Original Spikeball Kit 1-Ball',
      image:
        'https://www.spikeball.com/cdn/shop/files/media_d5f785c0-5090-47ab-bb7b-609b0dbc38b4.png?v=1728277750&width=600',
      description:
        'All you need for a fun and competitive (if you want) game of 2 vs. 2 Spikeball. Includes 1 Spikeball ball, Spikeball Set, drawstring bag, and rulebook. Play on grass, sand, or indoors.',
      brand: {
        '@type': 'Brand',
        name: 'Spikeball',
      },
      offers: {
        '@type': 'Offer',
        url: 'https://www.spikeball.com/products/original-spikeball-kit-1-ball',
        priceCurrency: 'USD',
        price: '59.00',
        priceValidUntil: '2024-12-31',
        itemCondition: 'https://schema.org/NewCondition',
        availability: 'https://schema.org/InStock',
        seller: {
          '@type': 'Organization',
          name: 'Spikeball',
        },
      },
      aggregateRating: {
        '@type': 'AggregateRating',
        ratingValue: '4.8',
        reviewCount: '162',
      },
      review: [
        {
          '@type': 'Review',
          author: {
            '@type': 'Person',
            name: 'Terry J.',
          },
          reviewRating: {
            '@type': 'Rating',
            ratingValue: '5',
            bestRating: '5',
          },
          datePublished: '2024-08-01',
          description:
            'Spikeball is an absolutely great game, I play very competitively with my friends all the time and it never gets old!',
        },
        {
          '@type': 'Review',
          author: {
            '@type': 'Person',
            name: 'Jovica E.',
          },
          reviewRating: {
            '@type': 'Rating',
            ratingValue: '5',
            bestRating: '5',
          },
          datePublished: '2024-07-15',
          description: 'Amazing game with amazing service!',
        },
        {
          '@type': 'Review',
          author: {
            '@type': 'Person',
            name: 'Matthew L.',
          },
          reviewRating: {
            '@type': 'Rating',
            ratingValue: '5',
            bestRating: '5',
          },
          datePublished: '2024-06-30',
          description: 'Such an easy and fun game to take on any trip!',
        },
      ],
      reviewHighlights: {
        '@type': 'ReviewHighlights',
        summary: "Customers appreciate the game's quality, ease of play, and customer service.",
        keywords: [
          {
            name: 'Game',
            mentions: '52% of reviewers',
          },
          {
            name: 'Fun',
            mentions: '5% of reviewers',
          },
          {
            name: 'Play',
            mentions: '5% of reviewers',
          },
          {
            name: 'Customer service',
            mentions: '4% of reviewers',
          },
          {
            name: 'Activity',
            mentions: '4% of reviewers',
          },
        ],
      },
    },
    '/products/spikeball-weekender-kit': {
      '@context': 'https://schema.org/',
      '@type': 'Product',
      name: 'Spikeball Weekender Set',
      image:
        'https://www.spikeball.com/cdn/shop/files/media_fb3b0acb-2284-401e-9b98-83944049b923.jpg?v=1728277781&width=800',
      description:
        'The classic Spikeball set just got an upgrade…introducing The Weekender set. Whether you’re road tripping through the mountains or barbecuing on the beach, this sturdy new set is down for the ride and guaranteed to get your people on their feet.',
      brand: {
        '@type': 'Brand',
        name: 'Spikeball',
      },
      offers: {
        '@type': 'Offer',
        url: 'https://www.spikeball.com/products/spikeball-weekender-set',
        priceCurrency: 'USD',
        price: '69.99',
        priceValidUntil: '2024-12-31',
        itemCondition: 'https://schema.org/NewCondition',
        availability: 'https://schema.org/InStock',
        seller: {
          '@type': 'Organization',
          name: 'Spikeball',
        },
      },
      aggregateRating: {
        '@type': 'AggregateRating',
        ratingValue: '2.7',
        reviewCount: '25',
      },
      review: [
        {
          '@type': 'Review',
          author: {
            '@type': 'Person',
            name: 'Israel Y.',
          },
          reviewRating: {
            '@type': 'Rating',
            ratingValue: '5',
            bestRating: '5',
          },
          datePublished: '2024-09-01',
          description:
            'I’ve played this game a lot with coworkers as a team building exercise. I received it as a gift from my kids and brought it camping for a family reunion. Great hit with the grandparents, parents, and teens!',
        },
        {
          '@type': 'Review',
          author: {
            '@type': 'Person',
            name: 'Kyle K.',
          },
          reviewRating: {
            '@type': 'Rating',
            ratingValue: '5',
            bestRating: '5',
          },
          datePublished: '2024-08-20',
          description:
            'Best backyard game of all time hands down. It’s fun, great exercise, and so easy to pick up & play.',
        },
        {
          '@type': 'Review',
          author: {
            '@type': 'Person',
            name: 'Justin',
          },
          reviewRating: {
            '@type': 'Rating',
            ratingValue: '1',
            bestRating: '5',
          },
          datePublished: '2024-09-15',
          description:
            'Poor quality. This product was used less than two weeks after purchase and a rim piece broke on both ends from regular play.',
        },
        {
          '@type': 'Review',
          author: {
            '@type': 'Person',
            name: 'Madalynn',
          },
          reviewRating: {
            '@type': 'Rating',
            ratingValue: '1',
            bestRating: '5',
          },
          datePublished: '2024-08-20',
          description:
            'Bought a spikeball net so I could play with my friends, the rim broke the 2nd time I played.',
        },
        {
          '@type': 'Review',
          author: {
            '@type': 'Person',
            name: 'Gian R.',
          },
          reviewRating: {
            '@type': 'Rating',
            ratingValue: '5',
            bestRating: '5',
          },
          datePublished: '2024-07-01',
          description:
            'This product is amazing, definitely a must-have at the beach. So much fun with friends and family!',
        },
      ],
      reviewHighlights: {
        '@type': 'ReviewHighlights',
        summary:
          'Customers appreciate the Spikeball Weekender set for its fun gameplay, but there are concerns about durability.',
        keywords: [
          {
            name: 'Game',
            mentions: '52% of reviewers',
          },
          {
            name: 'Durability',
            mentions: '48% of reviewers',
          },
          {
            name: 'Fun',
            mentions: '40% of reviewers',
          },
        ],
      },
    },
    '/products/spikebrite-play-in-the-dark': {
      '@context': 'https://schema.org/',
      '@type': 'Product',
      name: 'SpikeBrite - Play in the Dark',
      image:
        'https://www.spikeball.com/cdn/shop/files/media_2532df07-322c-4a36-a301-3a58cb524509.jpg?v=1728277721&width=600',
      description:
        'Your ability to play is no longer determined by the movement of the sun. SpikeBrite attaches to the top of your set’s legs. Batteries last over 2 hours and are rechargeable via micro USB.',
      brand: {
        '@type': 'Brand',
        name: 'Spikeball',
      },
      offers: {
        '@type': 'Offer',
        url: 'https://www.spikeball.com/products/spikebrite-play-in-the-dark',
        priceCurrency: 'USD',
        price: '29.00',
        priceValidUntil: '2024-12-31',
        itemCondition: 'https://schema.org/NewCondition',
        availability: 'https://schema.org/InStock',
        seller: {
          '@type': 'Organization',
          name: 'Spikeball',
        },
      },
      aggregateRating: {
        '@type': 'AggregateRating',
        ratingValue: '4.7',
        reviewCount: '145',
      },
      review: [
        {
          '@type': 'Review',
          author: {
            '@type': 'Person',
            name: 'Paul L.',
          },
          reviewRating: {
            '@type': 'Rating',
            ratingValue: '5',
            bestRating: '5',
          },
          datePublished: '2024-09-06',
          description:
            'The rims were great! They were very strong, bright, and had long-lasting batteries. The ball was ok but lost battery life faster than the rims.',
        },
        {
          '@type': 'Review',
          author: {
            '@type': 'Person',
            name: 'Tyler H.',
          },
          reviewRating: {
            '@type': 'Rating',
            ratingValue: '5',
            bestRating: '5',
          },
          datePublished: '2024-08-13',
          description: 'All of the parts are great quality and playing late at night is so much fun! 10/10',
        },
        {
          '@type': 'Review',
          author: {
            '@type': 'Person',
            name: 'Elijah M.',
          },
          reviewRating: {
            '@type': 'Rating',
            ratingValue: '5',
            bestRating: '5',
          },
          datePublished: '2024-06-01',
          description: 'The ball and rim are soooooooo bright! 100% worth it!',
        },
        {
          '@type': 'Review',
          author: {
            '@type': 'Person',
            name: 'Tyler',
          },
          reviewRating: {
            '@type': 'Rating',
            ratingValue: '2',
            bestRating: '5',
          },
          datePublished: '2024-07-30',
          description:
            'When using my spikebrite I had so much fun until both of the balls randomly stopped working and wouldn’t turn back on even after recharging.',
        },
        {
          '@type': 'Review',
          author: {
            '@type': 'Person',
            name: 'James',
          },
          reviewRating: {
            '@type': 'Rating',
            ratingValue: '5',
            bestRating: '5',
          },
          datePublished: '2024-07-04',
          description: 'Amazing purchase. I got my Spikebrite a year ago and it has worked very well.',
        },
      ],
      reviewHighlights: {
        '@type': 'ReviewHighlights',
        summary:
          'Customers love the bright rims and fun night play, though some have encountered issues with ball durability.',
        keywords: [
          {
            name: 'Balls',
            mentions: '22% of reviewers',
          },
          {
            name: 'Rim',
            mentions: '9% of reviewers',
          },
          {
            name: 'SpikeBrite',
            mentions: '8% of reviewers',
          },
          {
            name: 'Fun',
            mentions: '6% of reviewers',
          },
        ],
      },
    },
    '/products/spikebrite-pro-kit-bundle': {
      '@context': 'https://schema.org/',
      '@type': 'Product',
      name: 'SpikeBrite + Pro Kit Bundle',
      image:
        'https://www.spikeball.com/cdn/shop/files/media_6e4d0b1a-4709-494f-af65-275b5005d4d6.jpg?v=1721871588&width=800',
      description:
        'Take your game to the next level! The Pro Set is designed for better play and the best Spikeball experience. Add SpikeBrite to keep the game going all night long!',
      brand: {
        '@type': 'Brand',
        name: 'Spikeball',
      },
      offers: {
        '@type': 'Offer',
        url: 'https://www.spikeball.com/products/spikebrite-pro-kit-bundle',
        priceCurrency: 'USD',
        price: '129.00',
        priceValidUntil: '2024-12-31',
        itemCondition: 'https://schema.org/NewCondition',
        availability: 'https://schema.org/InStock',
        seller: {
          '@type': 'Organization',
          name: 'Spikeball',
        },
      },
      aggregateRating: {
        '@type': 'AggregateRating',
        ratingValue: '4.9',
        reviewCount: '25',
      },
      review: [
        {
          '@type': 'Review',
          author: {
            '@type': 'Person',
            name: 'Steve',
          },
          reviewRating: {
            '@type': 'Rating',
            ratingValue: '5',
            bestRating: '5',
          },
          datePublished: '2024-08-03',
          description:
            'My volleyball friends and I have quickly become obsessed with Spikeball. This particular bundle with the SpikeBrite has now gotten even more friends on board!',
        },
        {
          '@type': 'Review',
          author: {
            '@type': 'Person',
            name: 'Amy C.',
          },
          reviewRating: {
            '@type': 'Rating',
            ratingValue: '5',
            bestRating: '5',
          },
          datePublished: '2023-08-09',
          description:
            'Pro frame is definitely an upgrade and very sturdy. The light attaches easily and allows the fun to continue past sundown!',
        },
        {
          '@type': 'Review',
          author: {
            '@type': 'Person',
            name: 'Evan D.',
          },
          reviewRating: {
            '@type': 'Rating',
            ratingValue: '5',
            bestRating: '5',
          },
          datePublished: '2023-07-09',
          description: 'Goated product bruh.',
        },
        {
          '@type': 'Review',
          author: {
            '@type': 'Person',
            name: 'Michael S.',
          },
          reviewRating: {
            '@type': 'Rating',
            ratingValue: '5',
            bestRating: '5',
          },
          datePublished: '2022-11-28',
          description:
            'Awesome product that brings new life to an evening with friends! I am glad I got to add it to my collection.',
        },
        {
          '@type': 'Review',
          author: {
            '@type': 'Person',
            name: 'Cole L.',
          },
          reviewRating: {
            '@type': 'Rating',
            ratingValue: '5',
            bestRating: '5',
          },
          datePublished: '2022-06-22',
          description:
            'Great product, I like the pro Spikeball much better than the standard. And the SpikeBrite makes playing at night a lot easier and a lot more fun.',
        },
      ],
    },
    '/products/spikebouy-2-0': {
      '@context': 'https://schema.org/',
      '@type': 'Product',
      name: 'Spikebuoy 2.0',
      image:
        'https://www.spikeball.com/cdn/shop/files/media_6987a088-1973-43df-8fae-f27b92179d5d.jpg?v=1728277797&width=800',
      description:
        "Now compatible with Weekender kit! We meant it when we said PLAY ANYWHERE. Attach Spikebuoy to your Pro, Standard, or Weekender set, fill the anchor bag, and you're ready to play in the ocean, lake, pool, or that giant bathtub from Scarface.",
      brand: {
        '@type': 'Brand',
        name: 'Spikeball',
      },
      offers: {
        '@type': 'Offer',
        url: 'https://www.spikeball.com/products/spikebuoy-2-0',
        priceCurrency: 'USD',
        price: '34.99',
        priceValidUntil: '2024-12-31',
        itemCondition: 'https://schema.org/NewCondition',
        availability: 'https://schema.org/InStock',
        seller: {
          '@type': 'Organization',
          name: 'Spikeball',
        },
      },
      aggregateRating: {
        '@type': 'AggregateRating',
        ratingValue: '5',
        reviewCount: '1',
      },
      review: [
        {
          '@type': 'Review',
          author: {
            '@type': 'Person',
            name: 'Stefan L.',
          },
          reviewRating: {
            '@type': 'Rating',
            ratingValue: '5',
            bestRating: '5',
          },
          datePublished: '2024-09-04',
          description:
            "Tried this out at a lake, and it was fun although the water was way too cold for us to play more than one game. I feel like this would be perfect to play at the beach or somewhere on a day when the water's warmer!",
        },
      ],
    },
    '/products/spikepaddle-4-pack': {
      '@context': 'https://schema.org/',
      '@type': 'Product',
      name: 'SpikePaddle Kit',
      image:
        'https://www.spikeball.com/cdn/shop/files/media_89b1f3b6-f6e4-49de-9046-6f352833bf01.jpg?v=1728277889&width=800',
      description:
        "Introducing your new pair of hands: Spikepaddles. It's the same Spikeball you know and love but with paddles! Played in teams of two with up to 3 alternating hits before hitting it back on the net with Spikepaddles. Includes 4 Spikepaddles and 2 balls (one pickleball & one Spikepaddle ball). *Spikeball Kit not included.",
      brand: {
        '@type': 'Brand',
        name: 'Spikeball',
      },
      offers: {
        '@type': 'Offer',
        url: 'https://www.spikeball.com/products/spikepaddle-kit',
        priceCurrency: 'USD',
        price: '59.99',
        priceValidUntil: '2024-12-31',
        itemCondition: 'https://schema.org/NewCondition',
        availability: 'https://schema.org/InStock',
        seller: {
          '@type': 'Organization',
          name: 'Spikeball',
        },
      },
      aggregateRating: {
        '@type': 'AggregateRating',
        ratingValue: '4',
        reviewCount: '3',
      },
      review: [
        {
          '@type': 'Review',
          author: {
            '@type': 'Person',
            name: 'Elijah M.',
          },
          reviewRating: {
            '@type': 'Rating',
            ratingValue: '2',
            bestRating: '5',
          },
          datePublished: '2024-06-01',
          description:
            'Super cool concept, but why? If you love spikeball and pickleball, chances are you have pickleball paddles and spikeball, so why not just use the paddles you have?',
        },
        {
          '@type': 'Review',
          author: {
            '@type': 'Person',
            name: 'Stefan',
          },
          reviewRating: {
            '@type': 'Rating',
            ratingValue: '5',
            bestRating: '5',
          },
          datePublished: '2024-05-08',
          description:
            "I like the paddles, but my package didn't come with either balls provided. I'm bummed that I have the paddles but still neither ball.",
        },
        {
          '@type': 'Review',
          author: {
            '@type': 'Person',
            name: 'Anonymous',
          },
          reviewRating: {
            '@type': 'Rating',
            ratingValue: '5',
            bestRating: '5',
          },
          datePublished: '2024-04-24',
          description: 'I don’t have these but they look nice, would be fun to have.',
        },
      ],
    },
    '/products/standard-brite-bunddle': {
      '@context': 'https://schema.org/',
      '@type': 'Product',
      name: 'SpikeBrite + Standard 3 Ball Kit Bundle',
      image:
        'https://www.spikeball.com/cdn/shop/products/spikebrite-standard-3-ball-kit-bundle-973108-290307.jpg?v=1719421670&width=800',
      description:
        'All you need for a good time, day or night! This bundle includes our Best Seller the Standard 3 Ball Kit, as well as our new attachment, SpikeBrite.',
      brand: {
        '@type': 'Brand',
        name: 'Spikeball',
      },
      offers: {
        '@type': 'Offer',
        url: 'https://www.spikeball.com/products/spikebrite-standard-3-ball-kit-bundle',
        priceCurrency: 'USD',
        price: '114.00',
        priceValidUntil: '2024-12-31',
        itemCondition: 'https://schema.org/NewCondition',
        availability: 'https://schema.org/InStock',
        seller: {
          '@type': 'Organization',
          name: 'Spikeball',
        },
      },
      aggregateRating: {
        '@type': 'AggregateRating',
        ratingValue: '5',
        reviewCount: '8',
      },
      review: [
        {
          '@type': 'Review',
          author: {
            '@type': 'Person',
            name: 'Michael H.',
          },
          reviewRating: {
            '@type': 'Rating',
            ratingValue: '5',
            bestRating: '5',
          },
          datePublished: '2021-12-19',
          description:
            'The product works wonderful! The Spikebrite attachment really pops out. My friends and I enjoy it. Above all, the customer service was phenomenal for me. It has been a joy!',
        },
        {
          '@type': 'Review',
          author: {
            '@type': 'Person',
            name: 'Chris C.',
          },
          reviewRating: {
            '@type': 'Rating',
            ratingValue: '5',
            bestRating: '5',
          },
          datePublished: '2021-12-02',
          description:
            'Spikebrite is definitely a must have. Makes playing at night way easier and overall more fun!',
        },
        {
          '@type': 'Review',
          author: {
            '@type': 'Person',
            name: 'Cindy M.',
          },
          reviewRating: {
            '@type': 'Rating',
            ratingValue: '5',
            bestRating: '5',
          },
          datePublished: '2021-12-02',
          description:
            "Love love love Spikebrite! Super cool that there's USB cords for charging!! It's always a fun time with Spikeball, now at night!",
        },
        {
          '@type': 'Review',
          author: {
            '@type': 'Person',
            name: 'Michelle M.',
          },
          reviewRating: {
            '@type': 'Rating',
            ratingValue: '5',
            bestRating: '5',
          },
          datePublished: '2021-10-27',
          description:
            "Very cool game! We bought this for our daughter's 19th birthday!! She loves it!! Very easy to take places and anyone can play. We love the lights!!!",
        },
        {
          '@type': 'Review',
          author: {
            '@type': 'Person',
            name: 'Carson P.',
          },
          reviewRating: {
            '@type': 'Rating',
            ratingValue: '5',
            bestRating: '5',
          },
          datePublished: '2021-05-28',
          description:
            'This is a crazy cool product! I am now able to play at night and it is funnnn and to get both for the lower price was awesome. A purchase I will NEVER regret!',
        },
      ],
    },
    '/products/standard-kit-spares': {
      '@context': 'https://schema.org/',
      '@type': 'Product',
      name: 'Standard Kit Spares',
      image:
        'https://www.spikeball.com/cdn/shop/files/media_29b3cf91-8d43-4775-98c3-39be0439cf42.jpg?v=1727368856&width=800',
      description:
        "Don't get caught without a spare part! Make sure you can keep spiking if a part gets lost or broken by purchasing the Standard Kit Spares package. Includes 3 Standard Kit rims, 1 Standard Kit leg, and 1 Standard Kit net.",
      brand: {
        '@type': 'Brand',
        name: 'Spikeball',
      },
      offers: {
        '@type': 'Offer',
        url: 'https://www.spikeball.com/products/standard-kit-spares',
        priceCurrency: 'USD',
        price: '19.99',
        priceValidUntil: '2024-12-31',
        itemCondition: 'https://schema.org/NewCondition',
        availability: 'https://schema.org/InStock',
        seller: {
          '@type': 'Organization',
          name: 'Spikeball',
        },
      },
      aggregateRating: {
        '@type': 'AggregateRating',
        ratingValue: '4.5',
        reviewCount: '15',
      },
      review: [
        {
          '@type': 'Review',
          author: {
            '@type': 'Person',
            name: 'Jacob',
          },
          reviewRating: {
            '@type': 'Rating',
            ratingValue: '2',
            bestRating: '5',
          },
          datePublished: '2024-09-05',
          description:
            "I'm happy replacements are able to be ordered but $20 to only get 4/5 pieces does not seem like a good deal.",
        },
        {
          '@type': 'Review',
          author: {
            '@type': 'Person',
            name: 'Mary B.',
          },
          reviewRating: {
            '@type': 'Rating',
            ratingValue: '1',
            bestRating: '5',
          },
          datePublished: '2024-08-02',
          description:
            'This set does not fit the standard set from Academy, so now we are $100+ into this game and can’t even take it to the beach.',
        },
        {
          '@type': 'Review',
          author: {
            '@type': 'Person',
            name: 'Pete W.',
          },
          reviewRating: {
            '@type': 'Rating',
            ratingValue: '5',
            bestRating: '5',
          },
          datePublished: '2024-02-16',
          description:
            "I'm 64 and started playing Spikeball about 10 years ago and I love it. Luckily, I could order spare parts to fix my set!",
        },
        {
          '@type': 'Review',
          author: {
            '@type': 'Person',
            name: 'Blake B.',
          },
          reviewRating: {
            '@type': 'Rating',
            ratingValue: '5',
            bestRating: '5',
          },
          datePublished: '2023-09-09',
          description: "So glad I didn't have to buy a brand new set for one broken piece.",
        },
        {
          '@type': 'Review',
          author: {
            '@type': 'Person',
            name: 'Nathan V.',
          },
          reviewRating: {
            '@type': 'Rating',
            ratingValue: '5',
            bestRating: '5',
          },
          datePublished: '2023-09-02',
          description: 'Kit was exactly what I needed.',
        },
      ],
    },
    '/products/the-new-rookie-kit': {
      '@context': 'https://schema.org/',
      '@type': 'Product',
      name: 'THE NEW ROOKIE SET',
      image:
        'https://www.spikeball.com/cdn/shop/files/media_2d8846c2-7492-477f-b2ed-1c69267d04f4.jpg?v=1728277761&width=800',
      description:
        'Designed alongside PE teachers, the New Rookie Set is made for kids 13 and under. It comes with a larger ball and playing net than the standard Spikeball set, making it easier to learn the game and keep points going!',
      brand: {
        '@type': 'Brand',
        name: 'Spikeball',
      },
      offers: {
        '@type': 'Offer',
        url: 'https://www.spikeball.com/products/the-new-rookie-set',
        priceCurrency: 'USD',
        price: '59.00',
        priceValidUntil: '2024-12-31',
        itemCondition: 'https://schema.org/NewCondition',
        availability: 'https://schema.org/InStock',
        seller: {
          '@type': 'Organization',
          name: 'Spikeball',
        },
      },
      aggregateRating: {
        '@type': 'AggregateRating',
        ratingValue: '5',
        reviewCount: '1',
      },
      review: [
        {
          '@type': 'Review',
          author: {
            '@type': 'Person',
            name: 'Owen B.',
          },
          reviewRating: {
            '@type': 'Rating',
            ratingValue: '5',
            bestRating: '5',
          },
          datePublished: '2024-06-02',
          description:
            'Good for beginners that have just started but I think you should just learn on the pro or standard.',
        },
      ],
    },
    '/products/usa-weekender-set': {
      '@context': 'https://schema.org/',
      '@type': 'Product',
      name: 'USA Weekender Set',
      image:
        'https://www.spikeball.com/cdn/shop/files/media_96ea044a-0bd5-4c30-bd9b-fba250fadfac.jpg?v=1728277807&width=800',
      description:
        "Do you love apple pie? The smell of fresh cut grass? The imperial measuring system? This set was made for you. The eagle-lovin', flag-totin' patriot that you are. Get one before they're gone... for America.",
      brand: {
        '@type': 'Brand',
        name: 'Spikeball',
      },
      offers: {
        '@type': 'Offer',
        url: 'https://www.spikeball.com/products/usa-weekender-set',
        priceCurrency: 'USD',
        price: '69.99',
        priceValidUntil: '2024-12-31',
        itemCondition: 'https://schema.org/NewCondition',
        availability: 'https://schema.org/InStock',
        seller: {
          '@type': 'Organization',
          name: 'Spikeball',
        },
      },
      aggregateRating: {
        '@type': 'AggregateRating',
        ratingValue: '5',
        reviewCount: '1',
      },
      review: [
        {
          '@type': 'Review',
          author: {
            '@type': 'Person',
            name: 'Ethan E.',
          },
          reviewRating: {
            '@type': 'Rating',
            ratingValue: '5',
            bestRating: '5',
          },
          datePublished: '2024-05-06',
          description: 'Great for the summer.',
        },
      ],
    },
    '/products/weekender-kit-spares': {
      '@context': 'https://schema.org/',
      '@type': 'Product',
      name: 'Weekender Kit Spares',
      image:
        'https://www.spikeball.com/cdn/shop/files/media_456e13b6-dd09-48b2-846e-44097e828259.jpg?v=1721871991&width=800',
      description:
        "Don't get caught without a spare part! Make sure you can keep spiking if a part gets lost or broken by purchasing the Weekender Kit Spares package. Includes 3 Weekender Kit rims, 1 Weekender Kit leg, and 1 Weekender Kit net.",
      brand: {
        '@type': 'Brand',
        name: 'Spikeball',
      },
      offers: {
        '@type': 'Offer',
        url: 'https://www.spikeball.com/products/weekender-kit-spares',
        priceCurrency: 'USD',
        price: '19.99',
        priceValidUntil: '2024-12-31',
        itemCondition: 'https://schema.org/NewCondition',
        availability: 'https://schema.org/InStock',
        seller: {
          '@type': 'Organization',
          name: 'Spikeball',
        },
      },
      aggregateRating: {
        '@type': 'AggregateRating',
        ratingValue: '2.2',
        reviewCount: '5',
      },
      review: [
        {
          '@type': 'Review',
          author: {
            '@type': 'Person',
            name: 'Lamar',
          },
          reviewRating: {
            '@type': 'Rating',
            ratingValue: '5',
            bestRating: '5',
          },
          datePublished: '2024-08-26',
          description:
            'If the parts are the same as what I got in the set, then it should be fine. Only broke after someone threw a heavy water bottle at it by accident.',
        },
        {
          '@type': 'Review',
          author: {
            '@type': 'Person',
            name: 'Evan B.',
          },
          reviewRating: {
            '@type': 'Rating',
            ratingValue: '2',
            bestRating: '5',
          },
          datePublished: '2024-08-01',
          description: 'Fun but cheap and breaks. I’ve bought 2 sets and both have broken with light usage.',
        },
        {
          '@type': 'Review',
          author: {
            '@type': 'Person',
            name: 'Alex',
          },
          reviewRating: {
            '@type': 'Rating',
            ratingValue: '1',
            bestRating: '5',
          },
          datePublished: '2024-07-31',
          description:
            'Original sets broke the third time it was used by normal play, ordered replacements and went through them after only a month.',
        },
        {
          '@type': 'Review',
          author: {
            '@type': 'Person',
            name: 'LSM',
          },
          reviewRating: {
            '@type': 'Rating',
            ratingValue: '2',
            bestRating: '5',
          },
          datePublished: '2024-07-26',
          description:
            'Used 4-5 times and it has broken twice. My kids love the game but hate that it keeps breaking.',
        },
        {
          '@type': 'Review',
          author: {
            '@type': 'Person',
            name: 'Mike',
          },
          reviewRating: {
            '@type': 'Rating',
            ratingValue: '1',
            bestRating: '5',
          },
          datePublished: '2024-07-21',
          description:
            'Crappy product. Cheap materials. Breaks so easily and way too expensive. Not worth the money.',
        },
      ],
    },
    '/products/pro-rims-5-pack': {
      '@context': 'https://schema.org/',
      '@type': 'Product',
      name: 'Pro Rims - 5 Pack',
      image:
        'https://www.spikeball.com/cdn/shop/files/media_d55bc1d3-fa56-464d-a0fb-970ac7483aa0.jpg?v=1721870947&width=800',
      description:
        "Sometimes you gotta lay your body on the line to get that epic point and break a rim in the process. But don't worry, we've got you covered with this Pro Rims 5 Pack.",
      brand: {
        '@type': 'Brand',
        name: 'Spikeball',
      },
      offers: {
        '@type': 'Offer',
        url: 'https://www.spikeball.com/products/pro-rims-5-pack',
        priceCurrency: 'USD',
        price: '20.00',
        priceValidUntil: '2024-12-31',
        itemCondition: 'https://schema.org/NewCondition',
        availability: 'https://schema.org/InStock',
        seller: {
          '@type': 'Organization',
          name: 'Spikeball',
        },
      },
      aggregateRating: {
        '@type': 'AggregateRating',
        ratingValue: '5',
        reviewCount: '3',
      },
      review: [
        {
          '@type': 'Review',
          author: {
            '@type': 'Person',
            name: 'Tyler H.',
          },
          reviewRating: {
            '@type': 'Rating',
            ratingValue: '5',
            bestRating: '5',
          },
          datePublished: '2024-07-27',
          description:
            "I'm always careful with my net, but rims will still break sometimes. This is a great deal for replacement rims and now I can carry 6 rims at all times.",
        },
        {
          '@type': 'Review',
          author: {
            '@type': 'Person',
            name: 'Sage B.',
          },
          reviewRating: {
            '@type': 'Rating',
            ratingValue: '5',
            bestRating: '5',
          },
          datePublished: '2024-04-23',
          description: 'Great stuff.',
        },
        {
          '@type': 'Review',
          author: {
            '@type': 'Person',
            name: 'Weylin L.',
          },
          reviewRating: {
            '@type': 'Rating',
            ratingValue: '5',
            bestRating: '5',
          },
          datePublished: '2024-04-22',
          description:
            'Great set for beginners, does everything a pro set does (besides the rubber knubs on the bottom of the legs). 10/10 recommend!',
        },
      ],
    },
    '/pages/communities': {
      '@context': 'https://schema.org',
      '@type': 'WebPage',
      name: 'Roundnet Game Communities: Join the Movement',
      url: 'https://www.spikeball.com/pages/communities',
      description:
        'Discover how to connect, compete, and grow with local, college, and faith-based Spikeball groups. Start your circle today!',
      mainEntity: {
        '@type': 'Organization',
        name: 'Spikeball',
        url: 'https://www.spikeball.com',
        logo: 'https://www.spikeball.com/logo.png',
        sameAs: [
          'https://www.facebook.com/spikeball',
          'https://twitter.com/spikeball',
          'https://www.instagram.com/spikeball',
          'https://www.tiktok.com/@spikeball',
        ],
      },
      publisher: {
        '@type': 'Organization',
        name: 'Spikeball Inc.',
        logo: 'https://www.spikeball.com/logo.png',
      },
      image: 'https://www.spikeball.com/images/community-header.jpg',
      potentialAction: {
        '@type': 'Action',
        name: 'Join a Community',
        target: 'https://www.spikeball.com/pages/communities',
      },
    },
    '/pages/communities/college-clubs/': {
      '@context': 'https://schema.org',
      '@type': 'WebPage',
      name: 'College Roundnet Clubs: Join the Movement',
      url: 'https://www.spikeball.com/pages/communities/college-clubs',
      description:
        'Discover how to connect, compete, and grow with local, college, and faith-based Spikeball groups. Start your circle today!',
      mainEntity: {
        '@type': 'Organization',
        name: 'Spikeball',
        url: 'https://www.spikeball.com',
        logo: 'https://www.spikeball.com/logo.png',
        sameAs: [
          'https://www.facebook.com/spikeball',
          'https://twitter.com/spikeball',
          'https://www.instagram.com/spikeball',
          'https://www.tiktok.com/@spikeball',
        ],
      },
      publisher: {
        '@type': 'Organization',
        name: 'Spikeball Inc.',
        logo: 'https://www.spikeball.com/logo.png',
      },
      image: 'https://www.spikeball.com/images/community-header.jpg',
      potentialAction: {
        '@type': 'Action',
        name: 'Join a College Club',
        target: 'https://www.spikeball.com/pages/communities/college-clubs',
      },
    },
    '/pages/bring-spikeball-to-your-pe-class-fun-and-active-curriculum-for-all-ages': {
      '@context': 'https://schema.org',
      '@type': 'WebPage',
      name: 'Bring Spikeball to Your PE Class | Fun & Active Curriculum for All Ages',
      url: 'https://www.spikeball.com/pages/bring-spikeball-to-your-pe-class-fun-and-active-curriculum-for-all-ages',
      description:
        'Enhance your PE classes with Spikeball! Boost teamwork, fitness, and fun with easy-to-use equipment and free lesson plans for teachers.',
      mainEntity: {
        '@type': 'Organization',
        name: 'Spikeball Inc.',
        url: 'https://www.spikeball.com',
        logo: 'https://www.spikeball.com/logo.png',
        sameAs: [
          'https://www.facebook.com/spikeball',
          'https://twitter.com/spikeball',
          'https://www.instagram.com/spikeball',
          'https://www.tiktok.com/@spikeball',
        ],
      },
      publisher: {
        '@type': 'Organization',
        name: 'Spikeball Inc.',
        logo: 'https://www.spikeball.com/logo.png',
      },
      image: 'https://www.spikeball.com/images/pe-class.jpg',
      potentialAction: {
        '@type': 'Action',
        name: 'Request Free Spikeball Training',
        target: 'https://docs.google.com/forms/d/e/1FAIpQLSfD1Z2Yz3u7J6Z3JvQ/viewform',
      },
    },
    '/pages/faith-camps': {
      '@context': 'https://schema.org',
      '@type': 'WebPage',
      name: 'Spikeball for Faith Camps | Fun & Active Games for Youth Groups',
      url: 'https://www.spikeball.com/pages/faith-camps',
      description:
        'Engage faith youth groups with exciting games like Spikeball. Perfect for summer faith camps and youth nights, promoting teamwork, fun, and connection!',
      mainEntity: {
        '@type': 'Organization',
        name: 'Spikeball Inc.',
        url: 'https://www.spikeball.com',
        logo: 'https://www.spikeball.com/logo.png',
        sameAs: [
          'https://www.facebook.com/spikeball',
          'https://twitter.com/spikeball',
          'https://www.instagram.com/spikeball',
          'https://www.tiktok.com/@spikeball',
        ],
      },
      publisher: {
        '@type': 'Organization',
        name: 'Spikeball Inc.',
        logo: 'https://www.spikeball.com/logo.png',
      },
      image: 'https://www.spikeball.com/images/faith-camp.jpg',
      potentialAction: {
        '@type': 'Action',
        name: 'Bring Spikeball to Your Camp',
        target: 'https://www.spikeball.com/pages/faith-camps',
      },
    },
    '/pages/moms-with-teens': {
      '@context': 'https://schema.org',
      '@type': 'WebPage',
      name: 'Moms! Get Teens Moving with Fun, Active Games | Spikeball for Teens',
      url: 'https://www.spikeball.com/pages/moms-with-teens',
      description:
        'Encourage movement, reduce screen time, and boost social connections with fun outdoor activities for teens like Spikeball!',
      mainEntity: {
        '@type': 'Organization',
        name: 'Spikeball Inc.',
        url: 'https://www.spikeball.com',
        logo: 'https://www.spikeball.com/logo.png',
        sameAs: [
          'https://www.facebook.com/spikeball',
          'https://twitter.com/spikeball',
          'https://www.instagram.com/spikeball',
          'https://www.tiktok.com/@spikeball',
        ],
      },
      publisher: {
        '@type': 'Organization',
        name: 'Spikeball Inc.',
        logo: 'https://www.spikeball.com/logo.png',
      },
      image: 'https://www.spikeball.com/images/moms-with-teens.jpg',
      potentialAction: {
        '@type': 'Action',
        name: 'Join the Movement',
        target: 'https://www.spikeball.com/pages/moms-with-teens',
      },
    },
    '/pages/tournaments': {
      '@context': 'https://schema.org',
      '@type': 'WebPage',
      name: 'Spikeball Tournaments | Events & Competitions',
      url: 'https://www.spikeball.com/pages/tournaments',
      description:
        'Find and join Spikeball tournaments near you. Connect with local communities, participate in events, and compete in the sport of roundnet.',
      mainEntity: {
        '@type': 'Organization',
        name: 'Spikeball Inc.',
        url: 'https://www.spikeball.com',
        logo: 'https://www.spikeball.com/logo.png',
        sameAs: [
          'https://www.facebook.com/spikeball',
          'https://twitter.com/spikeball',
          'https://www.instagram.com/spikeball',
          'https://www.tiktok.com/@spikeball',
        ],
      },
      publisher: {
        '@type': 'Organization',
        name: 'Spikeball Inc.',
        logo: 'https://www.spikeball.com/logo.png',
      },
      image: 'https://www.spikeball.com/images/tournament-header.jpg',
      potentialAction: {
        '@type': 'Action',
        name: 'Find a Tournament',
        target: 'https://www.spikeball.com/pages/tournaments',
      },
    },
    '/pages/roundnet-101': {
      '@context': 'https://schema.org',
      '@type': 'WebPage',
      name: 'Roundnet 101 – Beginner’s Guide to Playing Spikeball',
      url: 'https://www.spikeball.com/pages/roundnet-101',
      description:
        'Learn the basics of roundnet (Spikeball) with our comprehensive guide. Discover how to set up your equipment, understand the rules, and start playing this exciting sport.',
      mainEntity: {
        '@type': 'Organization',
        name: 'Spikeball Inc.',
        url: 'https://www.spikeball.com',
        logo: 'https://www.spikeball.com/logo.png',
        sameAs: [
          'https://www.facebook.com/spikeball',
          'https://twitter.com/spikeball',
          'https://www.instagram.com/spikeball',
          'https://www.tiktok.com/@spikeball',
        ],
      },
      publisher: {
        '@type': 'Organization',
        name: 'Spikeball Inc.',
        logo: 'https://www.spikeball.com/logo.png',
      },
      image: 'https://www.spikeball.com/images/roundnet-101.jpg',
      potentialAction: {
        '@type': 'Action',
        name: 'Start Playing Roundnet',
        target: 'https://www.spikeball.com/pages/roundnet-101',
      },
    },
    '/pages/welcome-to-spikeschool': {
      '@context': 'https://schema.org',
      '@type': 'WebPage',
      name: 'Welcome to SpikeSchool – Learn How to Play Spikeball Like a Pro',
      url: 'https://www.spikeball.com/pages/welcome-to-spikeschool',
      description:
        'SpikeSchool offers tutorials and drills to enhance your Spikeball skills, from beginners to advanced players. Learn passing, hitting, defense, deception, and serving techniques.',
      mainEntity: {
        '@type': 'Organization',
        name: 'Spikeball Inc.',
        url: 'https://www.spikeball.com',
        logo: 'https://www.spikeball.com/logo.png',
        sameAs: [
          'https://www.facebook.com/spikeball',
          'https://twitter.com/spikeball',
          'https://www.instagram.com/spikeball',
          'https://www.tiktok.com/@spikeball',
        ],
      },
      publisher: {
        '@type': 'Organization',
        name: 'Spikeball Inc.',
        logo: 'https://www.spikeball.com/logo.png',
      },
      image: 'https://www.spikeball.com/images/spikeschool-header.jpg',
      potentialAction: {
        '@type': 'Action',
        name: 'Start Learning',
        target: 'https://www.spikeball.com/pages/welcome-to-spikeschool',
      },
    },
    '/pages/spikeball-rules-how-to-play': {
      '@context': 'https://schema.org',
      '@type': 'WebPage',
      name: 'How to Play Spikeball: Official Rules for Spikeball',
      url: 'https://www.spikeball.com/pages/spikeball-rules-how-to-play',
      description:
        'Learn the official rules of Spikeball (Roundnet), including serving, scoring, and gameplay mechanics. Perfect for beginners and enthusiasts.',
      mainEntity: {
        '@type': 'Organization',
        name: 'Spikeball Inc.',
        url: 'https://www.spikeball.com',
        logo: 'https://www.spikeball.com/logo.png',
        sameAs: [
          'https://www.facebook.com/spikeball',
          'https://twitter.com/spikeball',
          'https://www.instagram.com/spikeball',
          'https://www.tiktok.com/@spikeball',
        ],
      },
      publisher: {
        '@type': 'Organization',
        name: 'Spikeball Inc.',
        logo: 'https://www.spikeball.com/logo.png',
      },
      image: 'https://www.spikeball.com/images/spikeball-rules.jpg',
      potentialAction: {
        '@type': 'Action',
        name: 'Learn the Rules',
        target: 'https://www.spikeball.com/pages/spikeball-rules-how-to-play',
      },
    },
    '/pages/how-to-set-up-your-net': {
      '@context': 'https://schema.org',
      '@type': 'WebPage',
      name: 'How to Set Up Your Spikeball Net',
      url: 'https://www.spikeball.com/pages/how-to-set-up-your-net',
      description:
        'Follow our step-by-step guide to set up your Spikeball net and get playing in minutes. Suitable for Weekender, Pro, and Standard kits.',
      mainEntity: {
        '@type': 'Organization',
        name: 'Spikeball Inc.',
        url: 'https://www.spikeball.com',
        logo: 'https://www.spikeball.com/logo.png',
        sameAs: [
          'https://www.facebook.com/spikeball',
          'https://twitter.com/spikeball',
          'https://www.instagram.com/spikeball',
          'https://www.tiktok.com/@spikeball',
        ],
      },
      publisher: {
        '@type': 'Organization',
        name: 'Spikeball Inc.',
        logo: 'https://www.spikeball.com/logo.png',
      },
      image: 'https://www.spikeball.com/images/spikeball-net-setup.jpg',
      potentialAction: {
        '@type': 'Action',
        name: 'Start Setting Up',
        target: 'https://www.spikeball.com/pages/how-to-set-up-your-net',
      },
    },
    // Add more paths and schemas here as needed
  };

  // Get the current path
  var currentPath = window.location.pathname;

  // Check if the current path has a corresponding schema
  if (schemaMap[currentPath]) {
    insertSchema(schemaMap[currentPath]);
    console.log('Schema was found and matched for this path: ' + currentPath);
  } else {
    console.log('No schema found for this path: ' + currentPath);
  }
});
